import { z } from "zod";

export const createPlacementSchema = z.object({
  sponsor_id: z.string().min(1, "Sponsor is required"),
  ad_space_id: z.string().min(1, "Ad space is required"),
  package_id: z.string().nullable().optional(),
  start_date: z.string().regex(/^\d{4}-\d{2}-\d{2}$/, "Start date must be YYYY-MM-DD"),
  end_date: z.string().regex(/^\d{4}-\d{2}-\d{2}$/, "End date must be YYYY-MM-DD"),
  notes: z.string().max(1000).nullable().optional(),
});

export const updatePlacementSchema = z.object({
  status: z.enum(["reserved", "active", "expired", "cancelled"]).optional(),
  start_date: z.string().regex(/^\d{4}-\d{2}-\d{2}$/, "Start date must be YYYY-MM-DD").optional(),
  end_date: z.string().regex(/^\d{4}-\d{2}-\d{2}$/, "End date must be YYYY-MM-DD").optional(),
  notes: z.string().max(1000).nullable().optional(),
});

export type CreatePlacementInput = z.infer<typeof createPlacementSchema>;
export type UpdatePlacementInput = z.infer<typeof updatePlacementSchema>;
